import _ from 'lodash';
import api from '../../api';
import * as types from '../mutation-types';

const state = {
  detail: {},
  categoryDetail: [],
};

const getters = {
  // eslint-disable-next-line
  getArticleDetail: (s) => (id) => {
    return s.detail;
  },
};

const actions = {
  fetchArticleDetail({ commit }, id) {
    return api.article.getId(id).then(({ data: response }) => {
      commit(types.RECEIVE_ARTICLES_DETAIL, response.data);
    });
  },
  fetchArticleByCategory({ commit }, id) {
    return api.article.getCategoryById(id).then(({ data: response }) => {
      if (response.articles) {
        commit(types.RECEIVE_ARTICLE_BY_CATEGORY, response.articles);
      }
    });
  },
};
/* eslint no-param-reassign: 0 */
const mutations = {
  [types.RECEIVE_ARTICLES_DETAIL](s, data) {
    s.detail = data;
  },
  [types.RECEIVE_ARTICLE_BY_CATEGORY](s, data) {
    s.categoryDetail = _.uniqBy([...s.categoryDetail, ...data], 'id');
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
